import styled from 'styled-components';
import React, { ReactNode } from 'react';


type Props = {
  children: ReactNode
}

const CustomTitle = styled.span`
  font-weight: 500;
  margin-bottom: 16px;
`;
const RowSection: React.FC<Props> = ({ children }) => (<CustomTitle>{children}</CustomTitle>);

export default RowSection;